import { Component, inject } from "@angular/core";
import { AppDialog } from "@lib/base/services/dialog.service";
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from "@angular/material/dialog";
import { QueriedDataEntity } from "@lib/core/modules/graphql/graphql.types";
import { AnyFormDefinition } from "@lib/core/types/graphql-form.types";
import { GraphqlService } from "@lib/core/modules/graphql/graphql-service.service";
import { UnknownFormGroup } from "@lib/base/modules/form/dynamic-form/dynamic-form.types";
import { BehaviorSubject, combineLatest, filter } from "rxjs";
import { notNull } from "@lib/base/utils/object.utils";
import { autoExtractFirst } from "@lib/core/modules/graphql/prepare-input";
import { DynamicFormComponent } from "@lib/base/modules/form/components/forms/dynamic-form.component";
import { MatButton } from "@angular/material/button";
import { CloseAlertMutationGraphql } from "@workspace/pages/alerts/close-alert-dialog/close-alert.graphql";

type CloseDialogData = {
    model: QueriedDataEntity;
    form: AnyFormDefinition;
};

@Component({
    selector: "app-close-alert-dialog",
    imports: [
        MatDialogTitle,
        MatDialogContent,
        DynamicFormComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
    templateUrl: "./close-alert-dialog.component.html",
    styleUrl: "./close-alert-dialog.component.scss",
})
export class CloseAlertDialogComponent implements AppDialog<CloseDialogData> {
    dialogData: CloseDialogData = inject(MAT_DIALOG_DATA);
    graphqlService = inject(GraphqlService);
    dialogRef = inject(MatDialogRef);

    valueToPatch = this.graphqlService.query(this.dialogData.form.query).fetchOnce(this.dialogData.model);
    form = new BehaviorSubject<UnknownFormGroup | null>(null);

    formPatchSubscription = combineLatest({
        form: this.form.pipe(filter(notNull)),
        value: this.valueToPatch,
    }).subscribe(({ form, value }) => {
        form.patchValue(autoExtractFirst(value));
    });

    editModel() {
        if (!this.form.value?.valid) return;
        const formValue = this.form.value?.value;
        if (!formValue) return;
        const valueMutation = {
            id: this.dialogData.model.id,
            closingDescription: formValue["closingDescription"] as string ?? "",
        };
        this.graphqlService.mutate(CloseAlertMutationGraphql, valueMutation).subscribe(() => {
            this.dialogRef.close();
        });
    }
}
